import { isDevEnv } from "../common/utils";
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PROD =
  "pk_live_51I3ISlCfC9284d1FUS3ayiBhq1TxeR4XwA4NAvcfeNSE3AcA54LGO6hOMPV72NLdubeAUV5YlN1wBRb8Y5aMlV1100CVfH4qcC";
const STRIPE_DEV =
  "pk_test_51I3ISlCfC9284d1FaxN72iEuzZNEnuhD5Ir1rCuJtVBdJHR4vz9L1OsrFYJldD6Ib5yNTHNgo2adVIBqiT0ZWAKY00y496Kd25";
export const stripePromise = loadStripe(isDevEnv() ? STRIPE_DEV : STRIPE_PROD);
